<!-- components/Icon.vue -->
<script setup lang="ts">
import { HugeiconsIcon } from "@hugeicons/vue";
import { computed, type PropType } from "vue";
import { hugeIcons, type HugeIconName } from "@/icons/icons";

type IconValue = object | HugeIconName;

const props = defineProps({
  icon: { type: [Object, String] as PropType<IconValue>, required: true },
  altIcon: {
    type: [Object, String] as PropType<IconValue | null>,
    default: null,
  },
  showAlt: { type: Boolean, default: false },
  size: { type: Number, default: 16 },
  color: { type: String, default: 'currentColor' },
  strokeWidth: { type: Number, default: 1.2 },
})

const currentIcon = computed(() =>
  props.showAlt && props.altIcon ? props.altIcon : props.icon,
);

const resolvedIcon = computed(() => {
  if (typeof currentIcon.value === "string") {
    return hugeIcons[currentIcon.value] ?? null;
  }
  return currentIcon.value
})

function isStrokeIcon(icon: unknown): boolean {
  if (!Array.isArray(icon)) return false
  return icon.some(([, attrs]) => attrs && typeof attrs === 'object' && 'stroke' in attrs)
}

const isStroke = computed(() => isStrokeIcon(resolvedIcon.value))
</script>

<template>
  <HugeiconsIcon
    v-if="resolvedIcon"
    :icon="resolvedIcon"
    :size="size"
    :color="color"
    :class="{'icon-stroke' : isStroke}"
    :stroke-width="isStroke ? strokeWidth : undefined"
  />
</template>
